
export default function Reviews() {
  const reviews = [
    {
      rating: 5,
      title: '審査が不安でしたが無事に発行できました',
      content: '過去にカード審査で落ちた経験があり不安でしたが、デポジット型なので無事に発行できました。フリーランスとして経費の支払いに使えて助かっています。',
      author: '30代 男性 フリーランス',
    },
    {
      rating: 4,
      title: '使いすぎ防止になって良い',
      content: 'デポジット額が利用限度額になるので、使いすぎる心配がありません。自分で限度額をコントロールできるのが気に入っています。',
      author: '40代 女性 会社員',
    },
    {
      rating: 4,
      title: 'ネットショッピングで重宝',
      content: 'Mastercardなので使えるお店が多く、ネットショッピングで重宝しています。ポイントも貯まるので、デジタルギフトに交換して使っています。',
      author: '20代 男性 学生',
    },
    {
      rating: 5,
      title: '個人事業主の経費管理に最適',
      content: '個人事業主として経費の支払いをカードにまとめたかったのですが、他のカードは審査が厳しく…。このカードは無事に発行でき、経費管理が楽になりました。',
      author: '50代 男性 個人事業主',
    },
  ];

  const averageRating = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          デポジット型クレジットカードの口コミ・評判
        </h2>
        <div className="flex items-center justify-center gap-2 mb-12">
          <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <i
                key={star}
                className={`ri-star-fill text-xl ${star <= Math.round(Number(averageRating)) ? 'text-[#FFD700]' : 'text-gray-300'}`}
              ></i>
            ))}
          </div>
          <span className="text-2xl font-bold text-[#003366]">{averageRating}</span>
          <span className="text-gray-600">/ 5.0</span>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-[#F8F9FA] rounded-xl p-6">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`ri-star-fill ${star <= review.rating ? 'text-[#FFD700]' : 'text-gray-300'}`}
                  ></i>
                ))}
              </div>
              <h3 className="font-bold text-[#003366] mb-2">{review.title}</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">{review.content}</p>
              <p className="text-gray-500 text-xs">{review.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
